/**
 * @preserve
 * Licenses of bundled dependencies can be found in dependencies-licenses.txt
 */
function isInternetExplorer(){return window.navigator.userAgent.indexOf("MSIE ")>0||Boolean(navigator.userAgent.match(/Trident.*rv:11\./))}export{isInternetExplorer as i};
//# sourceMappingURL=is-internet-explorer-cfdb9be2.js.map